import Handlebars from 'handlebars/dist/handlebars'
import asyncHelpers from 'handlebars-async-helpers'

export const asyncHandlebars = asyncHelpers(Handlebars)
